import React from 'react';
import '../LegalPage/LegalPage.scss';

export default function TermsOfService() {
  return (
    <main className="legal-page">
      <section className="legal-page__hero">
        <p className="legal-page__eyebrow">The Tour Golfers</p>
        <h1>Terms of Service</h1>
        <p>Effective Date: May 2026</p>
      </section>

      <section className="legal-page__content">
        <p>
          These Terms of Service (“Terms”) govern your access to and use of The
          Tour Golfers mobile application, website, and related services. By creating
          an account or using the platform, you agree to these Terms.
        </p>

        <h2>1. Eligibility</h2>
        <p>
          You must be at least 13 years old to use The Tour Golfers. If you are
          under the age of majority in your jurisdiction, you represent that you
          have permission from a parent or legal guardian.
        </p>

        <h2>2. User Accounts</h2>
        <ul>
          <li>You are responsible for maintaining your account credentials.</li>
          <li>You are responsible for activity under your account.</li>
          <li>You must provide accurate account information.</li>
          <li>You may not impersonate another person or organization.</li>
        </ul>

        <h2>3. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Harass, threaten, abuse, or intimidate other users</li>
          <li>Post hateful, discriminatory, illegal, or offensive content</li>
          <li>Spam, manipulate, or abuse platform features</li>
          <li>Attempt unauthorized access to accounts, systems, or data</li>
          <li>Upload content you do not own or have permission to share</li>
          <li>Submit false, misleading, or intentionally manipulated golf activity</li>
        </ul>

        <h2>4. User Content</h2>
        <p>
          You retain ownership of content you submit, including comments, profile
          images, golf activity, and other user-generated content. By submitting
          content, you grant The Tour Golfers a non-exclusive, worldwide, royalty-free
          license to host, display, process, and operate that content within the
          platform.
        </p>

        <h2>5. Moderation</h2>
        <p>
          We may review, hide, remove, or restrict content that violates these Terms
          or our Community Guidelines. Users may report content and block other users.
          We may suspend or terminate accounts involved in harassment, spam, fraud,
          abusive conduct, or platform misuse.
        </p>

        <h2>6. Golf, Yardage, and Competition Disclaimer</h2>
        <p>
          The Tour Golfers provides recreational golf tools. Yardages, statistics,
          leaderboards, tournaments, and course-related information may be approximate
          and should not be relied on as official tournament, safety, or course
          management information.
        </p>

        <h2>7. Intellectual Property</h2>
        <p>
          The Tour Golfers name, branding, design, software, logos, interface, and
          platform materials are owned by The Tour Golfers and may not be copied,
          modified, or used without permission.
        </p>

        <h2>8. Account Deletion</h2>
        <p>
          You may delete your account directly within the app. Deletion is permanent
          and may remove associated profile, score, social, and activity data.
        </p>

        <h2>9. Service Availability</h2>
        <p>
          The platform is provided on an “as is” and “as available” basis. We do
          not guarantee uninterrupted service, error-free operation, or permanent
          data availability.
        </p>

        <h2>10. Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by law, The Tour Golfers is not liable for
          indirect damages, lost data, user disputes, service interruptions, or
          reliance on user-generated content or app-generated statistics.
        </p>

        <h2>11. Changes to These Terms</h2>
        <p>
          We may update these Terms periodically. Continued use of the platform after
          updates means you accept the revised Terms.
        </p>

        <h2>12. Contact</h2>
        <p>
          Questions about these Terms can be sent to{' '}
          <a href="mailto:support@thetourgolfers.com">support@thetourgolfers.com</a>.
        </p>
      </section>
    </main>
  );
}